import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import Calendar from '../../../components/calendar/Calendar.js';
import dayjs from "dayjs";
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminReferenceHoliday(props) {
    const formRef = useRef(null)

    const [reportdate_filter, setReportdate_filter] = useState(dayjs(new Date()));
    const [datalist, setDatalist] = useState([]);
    const [dataitem, setDataitem] = useState({
        datetimestamp: dayjs(new Date()),
        date_name: 'calendar',
        date_custom: '',
    });
    const [holidaylist, setHolidaylist] = useState([
        { datetimestamp: '01-01', date_th: 'วันที่ 1 มกราคม ', date_desc: 'วันขึ้นปีใหม่' },
        { datetimestamp: '03-03', date_th: 'วันที่ 3 มีนาคม ', date_desc: 'วันมาฆบูชา' },
        { datetimestamp: '04-06', date_th: 'วันที่ 6 เมษายน ', date_desc: 'วันพระบาทสนเด็จพระพุทระพุทธยอดฟ้าจุหาโลกมหาราชและวันที่ระลึกมหาจักรีบรมราชวงศ์' },
        { datetimestamp: '04-13', date_th: 'วันที่ 13 เมษายน ', date_desc: 'วันสงกรานต์' },
        { datetimestamp: '04-14', date_th: 'วันที่ 14 เมษายน ', date_desc: 'วันสงกรานต์' },
        { datetimestamp: '04-15', date_th: 'วันที่ 15 เมษายน ', date_desc: 'วันสงกรานต์' },
        { datetimestamp: '05-01', date_th: 'วันที่ 1 พฤษภาคม ', date_desc: 'วันแรงงานแห่งชาติ' },
        { datetimestamp: '05-04', date_th: 'วันที่ 4 พฤษภาคม ', date_desc: 'วันฉัตรมงคล' },
        { datetimestamp: '06-03', date_th: 'วันที่ 3 มิถุนายน ', date_desc: 'วันเฉลิมพระหนมพรพรรรษาสมเด็จพระนางเจ้าสุทิดา พัชรสุธาพิมลลักษณ พระบรมราชินี' },
        { datetimestamp: '07-28', date_th: 'วันที่ 3 มิถุนายน ', date_desc: 'วันเฉลิมพระชนมพรรษาพระบาทสมเด็จพระปรเมนทรรามาธิบดีศรีสินทรมหาวชิราลงกรณ พระวชิรเกล้าเจ้าอยู่หัว' },
        { datetimestamp: '07-29', date_th: 'วันที่ 29 กรกฎาคม ', date_desc: 'วันอาสาฬหบูชา' },
        { datetimestamp: '07-30', date_th: 'วันที่ 30 กรกฎาคม ', date_desc: 'วันเข้าพรรษา' },
        { datetimestamp: '08-12', date_th: 'วันที่ 12 สิงหาคม ', date_desc: 'วันเฉลิมพระชนมพรรษาสมเด็จพระบรมราชชนนีพันปีหลวงและวันแม่แห่งชาติ' },
        { datetimestamp: '10-13', date_th: 'วันที่ 13 ตุลาคม ', date_desc: 'วันนวมินทรมหาราช' },
        { datetimestamp: '10-23', date_th: 'วันที่ 23 ตุลาคม ', date_desc: 'วันปิยมหาราช' },
        { datetimestamp: '12-10', date_th: 'วันที่ 10 ธันวาคม ', date_desc: 'วันรัฐธรรมนูญ' },
        { datetimestamp: '12-31', date_th: 'วันที่ 31 ธันวาคม ', date_desc: 'วันสิ้นปี' }
    ]);
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_item, setModal_item] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const onCalendarChange_Filter = (date, dateString) => {
        setReportdate_filter(date)
    };
    const onCalendarChange_Add = (date, dateString) => {
        setDataitem({
            ...dataitem,
            datetimestamp: date,
        })
    };
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        api_delete(message)
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        api_load()
    }, [reportdate_filter]);

    function init_item() {
        setDataitem({
            datetimestamp: dayjs(new Date()),
            date_name: 'calendar',
            date_custom: '',
        })
    }

    useEffect(() => {
        return () => {
            setDatalist([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading holiday list." })
        await sleep(500)

        const formData = new FormData()
        formData.append('year', dayjs(reportdate_filter).format('YYYY'))
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refholiday/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.holiday !== null && response.data.holiday !== undefined) {
                    setDatalist(response.data.holiday)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_add() {
        var formelement = formRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");

            setmodal_load({ enable: true, message: "Adding a holiday to a database." })
            await sleep(500)

            const formData = new FormData()
            const cyear = dayjs(reportdate_filter).format('YYYY')
            formData.append('year', cyear)
            if (dataitem.date_name !== 'calendar') {
                formData.append('datetimestamp', cyear + '-' + dataitem.date_name)
                const found = holidaylist.find((element, id) => element.datetimestamp === dataitem.date_name);
                if (found !== undefined) {
                    formData.append('date_name', found.date_desc)
                }
            } else {
                formData.append('datetimestamp', dayjs(dataitem.datetimestamp).format('YYYY-MM-DD') + ' 00:00:00')
                formData.append('date_name', dataitem.date_custom)
            }
            axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refholiday/add", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_item(false)
                    init_item()
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your holiday has been added to a database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.holiday !== null && response.data.holiday !== undefined) {
                        setDatalist(response.data.holiday)
                    } else {
                        setDatalist([])
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_delete(datetime) {
        setmodal_load({ enable: true, message: "Deleting a holiday in a database." })
        await sleep(500)

        const formData = new FormData()
        formData.append('year', dayjs(reportdate_filter).format('YYYY'))
        formData.append('datetimestamp', datetime)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/refholiday/delete", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your holiday has been deleted in a database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.holiday !== null && response.data.holiday !== undefined) {
                    setDatalist(response.data.holiday)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> Holiday Calendar</h4>
                                    <p className="mb-0">Manage all days of off-peak date</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { setModal_item(true) }}><i className="fas fa-plus"></i> Add</button>
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className='d-flex'>
                            <div className="d-block ">
                                <label htmlFor="reporttype" className="form-label mb-0">Select Year Filter</label>
                                <Calendar
                                    allowClear={false}
                                    className={"form-control"}
                                    onChange={onCalendarChange_Filter}
                                    picker={'year'}
                                    style={{
                                        fontFamily: "poppins",
                                        fontSize: "0.75rem",
                                        Color: "black",
                                        lineHeight: "1.5",
                                        cursor: "pointer",
                                    }}
                                    value={reportdate_filter}
                                />
                            </div>
                        </div>

                        <h5 className='mt-3'>Holiday Table (Found {datalist.length} Days)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th style={{ width: "50px" }}>#</th>
                                        <th style={{ width: "220px" }}>Date EN</th>
                                        <th style={{ width: "220px" }}>Date TH</th>
                                        <th>Date Description</th>
                                        <th>Edit Time</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role === "Admin" ?
                                                    <th className="text-center" style={{ width: "100px" }}>Action</th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.datetimestamp}>
                                                <td>{index + 1}</td>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp_en}</td>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.datetimestamp_th}</td>
                                                <td>{data.holiday_base ? "วันหยุดประจำสัปดาห์" : data.date_name}</td>
                                                <td>{data.edittime}</td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role === "Admin" && data.holiday_base === false ?
                                                            <td>
                                                                <Link className="btn btn-icon btn-sm btn-danger btn-hover btn-bordered" title="Delete"
                                                                    onClick={() => {
                                                                        setModal_popup({
                                                                            modaltype: 'modal-confirm',
                                                                            headers: 'Confirmation',
                                                                            message: "Please click on confirm button to continue this operation.",
                                                                            enable: true,
                                                                            confirmcode: data.datetimestamp,
                                                                        });
                                                                    }}><i className="fas fa-eraser"></i></Link>
                                                            </td>
                                                            :
                                                            <td><div style={{ height: "25px" }}>-</div></td>
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {
                        modal_item ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-md modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-calendar-alt"></i> Add Holiday Calendar</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_item(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-1">
                                                        <div className="col-md-8">
                                                            <div className="form-group">
                                                                <label htmlFor="date_name">Select Quick Date</label>
                                                                <select name="date_name" className="form-select" value={dataitem.date_name} onChange={(e) => {
                                                                    setDataitem({
                                                                        ...dataitem,
                                                                        date_name: e.target.value
                                                                    })
                                                                }} required>
                                                                    <option value="calendar">Calendar</option>
                                                                    {
                                                                        holidaylist.map((data, index) => (
                                                                            <option key={data.datetimestamp} value={data.datetimestamp}>{data.date_th} {data.date_desc}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        dataitem.date_name === 'calendar' ?
                                                            <>
                                                                <div className="row mb-1">
                                                                    <div className="col-md-8">
                                                                        <div className="d-block ">
                                                                            <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                                                                            <Calendar
                                                                                allowClear={false}
                                                                                className={"form-control"}
                                                                                onChange={onCalendarChange_Add}
                                                                                picker={'days'}
                                                                                style={{
                                                                                    fontFamily: "poppins",
                                                                                    fontSize: "0.75rem",
                                                                                    Color: "black",
                                                                                    lineHeight: "1.5",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                value={dataitem.datetimestamp}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-1">
                                                                    <div className="col-md-12">
                                                                        <div className="form-group mb-3">
                                                                            <label htmlFor="date_desc">Date Description</label>
                                                                            <input type="text" className="form-control" name="date_desc" value={dataitem.date_custom} required onChange={(e) => {
                                                                                setDataitem({
                                                                                    ...dataitem,
                                                                                    date_custom: e.target.value
                                                                                })
                                                                            }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            : null
                                                    }
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_item(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_add() }}><i className="fe-save"></i> OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceHoliday